import { useMemo } from 'react';
import { useOutletContext } from 'react-router-dom';
import { get, isEqual } from 'lodash-es';
import { SortChangedEvent } from 'ag-grid-community';

import { DashboardTableOutlet } from './constants';
import { useGetUserProfileInfoQuery } from '../../Settings/MyProfile/queries';
import { useGetUserViewsPreferenceQuery, useUpdatePersistedSortMutation } from '../queries';
import { ViewOption } from '../queries/apiTypes';
import { useGetAuthToken } from 'src/features/Authentication/hooks';
import { getSortedColumns } from './utils';
import { EventServicePageNameTypes } from 'src/features/shared/ManageColumnsPopup/queries/apiTypes';

export function useDashboardOutletContext() {
    return useOutletContext<DashboardTableOutlet>();
}
export const useGetUserDashboardViews = () => {
    const { token } = useGetAuthToken();

    const { data: userData, isFetching: isUserDataFetching } = useGetUserProfileInfoQuery({ enabled: Boolean(token) });
    const { data: dashboardViewsData, isFetching: isDashboardViewsFetching } = useGetUserViewsPreferenceQuery(userData?.data?.id || 0, {
        enabled: Boolean(userData?.data?.id)
    });
    const defaultSelectedView: ViewOption = 'my_work';

    const dashboardSelectedViews = useMemo(() => {
        if (isDashboardViewsFetching) return null;
        if (dashboardViewsData?.user_view_preference?.length > 0) return dashboardViewsData?.user_view_preference[0]?.dashboard_view;
        return defaultSelectedView;
    }, [dashboardViewsData?.user_view_preference, isDashboardViewsFetching]);

    const isDashboardViewsLoading = isUserDataFetching || isDashboardViewsFetching;

    return { isDashboardViewsLoading, dashboardSelectedViews };
};

export const useSortChange = (
    pageName: EventServicePageNameTypes, userId: number, selectedColumnsAndFiltersQueryData: any
) => {
    const { mutate: updateSortFieldMutation } = useUpdatePersistedSortMutation();

    // To support multi column sort(in future), saving columns sort state in an object of objects
    const handleSortChanged = (params: SortChangedEvent) => {
        const columnsState = params.api.getColumnState();
        if (!Array.isArray(columnsState)) return;


        const payload = getSortedColumns(columnsState);
        const apiResponse = get(selectedColumnsAndFiltersQueryData, "table_settings[0].sort_field");

        console.log({ columnsState, payload, apiResponse })

        if (!isEqual(apiResponse, payload)) {
            updateSortFieldMutation({
                pageName,
                userId,
                payload,
            });
        }
    };

    return { handleSortChanged };
}